import type { RootState } from '@app/model/types'
import { getPageStateSafe } from '@app/model/store/helpers'

import { listingInitialState } from './initialState'
import type { ListingState } from './types'

export const selectListingState = (state: RootState): ListingState =>
  getPageStateSafe(state, 'listing', listingInitialState)

export const selectListingList = (state: RootState) => selectListingState(state).list

export const selectListingSelections = (state: RootState) => selectListingState(state).selections
